import { mapActions, mapState } from "vuex";
import store from "@/store/store";
import {
  signInUser,
  loadAllUserData,
  ENUM_LOGIN_WIN_MODES,
} from "@/services/login";

export default {
  methods: {
    ...mapActions("user", ["login", "setUserData", "setUser"]),
    showLoginWin() {
      this.$store.state.user.loginTab = 1;
      this.$store.state.user.showLoginMode = ENUM_LOGIN_WIN_MODES.LOGIN;
      this.$store.state.user.showLogin = true;
    },
    showLoginWinFull(user) {
      if (user.userData.connectionInfo?.switchApps)
        this.$store.state.user.showLoginMode = ENUM_LOGIN_WIN_MODES.SWITCHAPPS;
      else
        this.$store.state.user.showLoginMode =
          ENUM_LOGIN_WIN_MODES.STATIONS_FULL;

      this.$store.state.user.showLogin = true;
    },
    showConnectionOptions() {
      this.$store.state.user.showLoginMode = ENUM_LOGIN_WIN_MODES.APP_CHOOSE;
      this.$store.state.user.showLogin = true;
    },
    async loginOnlineCheck() {
      signInUser({ autoConnect: false })
        .then((user) => {
          if (user) {
            this.setUser(user).then(() => {
              if (!user.userData.error) loadAllUserData();
            });
          } else this.showLoginWin();
        })
        .catch((err) => console.error(err));
    },
    async loginOffline() {
      //auto connect user
      await this.login({
        username: "זמני",
        password: "1234",
      });
    },
    async loginOnline(data) {
      let user = localStorage.getItem("user");
      let authCookie = getCookie("aut");
      let enc = "",
        ui = 0,
        parsedCook = {};
      if (authCookie) {
        parsedCook = parseQueryString(authCookie);
        enc = parsedCook.enc;
        ui = parsedCook.ui;
      }
      if (user) {
        //if user exists - verify it
        user = JSON.parse(user);
        if (user.userData.userType != "GUEST" || ui == 0)
          data = {
            token: user.token,
            ...data,
          };
        else data = { ...data, domainAuth: enc, ui: ui };
      } else if (ui > 0) data = { ...data, domainAuth: enc, ui };

      user = await signInUser(data);

      if (user) {
        this.showLoginMessage(user);
        if (
          !(
            user.userData.connectionInfo?.switchApps &&
            user.userData.connectionInfo?.full
          )
        )
          this.setUser(user);
        store.state.user.reactAppConnection++;
        return true;
        //  this.$router.push(this.to);
      } else {
        return false;
        this.$router.replace({
          name: "lic_error",
          params: { err: this.$t("errors.userError"), code: 200 },
        });
      }
    },
    showLoginMessage(user) {
      if (user.userData.connectionInfo?.full) {
        this.showLoginWinFull(user);
      } else if (
        user.userData.connectionInfo?.type == "both" &&
        user.userData.connectionInfo?.chooseApps
      ) {
        this.showConnectionOptions();
      }
    },
    setOnlineUnloadEvent() {
      if (globalThis.SERVER_MODE == "offline") return;
      window.addEventListener("beforeunload", this.disconnectUser);
      window.addEventListener("unload", this.disconnectUser);
    },
    disconnectUser() {
      this.$socket.client.emit("logout");
    },
  },
};

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function parseQueryString(queryString) {
  return queryString.split("&").reduce((acc, param) => {
    let [key, value] = param.split("=");
    acc[key] = value;
    return acc;
  }, {});
}
